import { render, staticRenderFns } from "./StudentFaceModal__Style#Drawer.vue?vue&type=template&id=c7a4b630&scoped=true"
import script from "./StudentFaceModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./StudentFaceModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./StudentFaceModal__Style#Drawer.vue?vue&type=style&index=0&id=c7a4b630&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a4b630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a4b630')) {
      api.createRecord('c7a4b630', component.options)
    } else {
      api.reload('c7a4b630', component.options)
    }
    module.hot.accept("./StudentFaceModal__Style#Drawer.vue?vue&type=template&id=c7a4b630&scoped=true", function () {
      api.rerender('c7a4b630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentFace/modules/StudentFaceModal__Style#Drawer.vue"
export default component.exports